import { render, staticRenderFns } from "./RecurringPaymentsProductManagementIframe.vue?vue&type=template&id=0d087593&"
import script from "./RecurringPaymentsProductManagementIframe.vue?vue&type=script&lang=ts&"
export * from "./RecurringPaymentsProductManagementIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports